export const API_KEY = 'AIzaSyDshC1CWnnSf92AlC-5w0-o6DLAfQQZs70'
export const RECAPTCHA = '6LePxkklAAAAABJyYBkk3EcWGNNlGYjDS63WJDp4'
export const CACHING_TIME = 30000
export const DROPBOX_API_KEY = 'r0aeqq6jb5nhvhr'
// x9e24r3mc77upbe
export const GOOGLE_API_KEY = 'AIzaSyBcXTjG45zKerY6XarnFwvg0YucCCSmepo'
export const GOOGLE_CLIENT_ID = '773635034128-iqiumu7e3736ru19i0cqdbp0un0j2ioq.apps.googleusercontent.com'
export const MICROSOFT_CLIENT_ID = '1b3dff25-d868-43ba-b2b4-d2febc37b518'

export const FILE_TYPES = {
    CV: {
        EXT: ['pdf', 'docx', 'doc'],
        MIME: [
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/msword',
            'application/pdf',
        ],
    },
    ATTACHMENTS: {
        EXT: [
            'doc',
            'ics',
            'eml',
            'docx',
            'gif',
            'tif',
            'dotx',
            'potx',
            'xltx',
            'docm',
            'jpg',
            'mov',
            'csv',
            'xml',
            'key',
            'nda',
            'dat',
            'jpeg',
            'rtf',
            'pptx',
            'mp4',
            'pdf',
            'msg',
            'png',
            'ppt',
            'xls',
            'numbers',
            'odt',
            'svg',
            'xlsx',
            'xlsm',
            'txt',
            'tiff',
            'psd',
            'eps',
            'ai',
            'json',
            'zip',
            'pages',
            'rar',
            'pps',
            'pptm',
        ],
        MIME: [
            'image/jpeg',
            'image/png',
            'image/webp',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'text/plain',
            'application/pdf',
            'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/rtf',
            'text/rtf',
            'text/calendar',
            'message/rfc822',
            'image/gif',
            'image/tiff',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
            'application/vnd.openxmlformats-officedocument.presentationml.template',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
            'application/vnd.ms-word.document.macroEnabled.12',
            'video/quicktime',
            'text/csv',
            'application/msword',
            'application/xml',
            'application/pkcs8',
            'application/x-pds',
            'video/mp4',
            'application/vnd.ms-outlook',
            'application/vnd.ms-powerpoint',
            'application/excel',
            'application/x-excel',
            'application/vnd.ms-excel',
            'application/x-ms-excel',
            'application/x-dos_ms_excel',
            'application/x-iwork-numbers-sffnumbers',
            'application/x-iwork-pages-sffpages',
            'application/vnd.apple.numbers',
            'application/vnd.oasis.opendocument.text',
            'image/svg-xml',
            'image/svg+xml',
            'image/svg',
            'application/vnd.ms-excel.sheet.macroEnabled.12',
            'image/tiff',
            'image/psd',
            'application/postscript',
            'application/json',
            'application/octet-stream',
            'application/zip',
            'application/vnd.apple.pages',
            'application/vnd.rar',
            'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
            'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
        ],
    },
}
